'use strict';

/* jshint -W098 */
angular.module('mean.messages').controller('MessagesController', ['$scope', 'Global', 'Messages', 'Users', 'MeanUser', '$filter', 'MessageDetail', 'Archives',
  function($scope, Global, Messages, Users, MeanUser, $filter, MessageDetail, Archives) {
    $scope.global = Global;
    $scope.package = {
      name: 'messages'
    };

    $scope.total_messages = 0;
    $scope.total_unread = 0;
    $scope.total_inbox = 0;
    $scope.checkSelection = [];
    $scope.selectedItems = [];

    Users.query({}, 'username name', function(users) {
    	$scope.users = users;
    });

    Messages.query({'receiver': MeanUser.user._id, 'where': 'sender subject date folder status'}, function(messages) {
    	$scope.my_messages = $filter('orderBy')(messages, '-date', false);
      $scope.my_inbox_messages = $filter('filter')($scope.my_messages, {'folder': 'inbox'}, true);
      $scope.my_trash_messages = $filter('filter')($scope.my_messages, {'folder': 'trash'}, true);

      $scope.total_messages = $scope.my_messages.length;

      var unread = 0;
      var inbox = 0;
      $scope.my_messages.forEach(function(message) {
        if(message.folder === 'inbox') {
          inbox = inbox + 1;
        
          if(message.status === 'unread') {
            unread = unread + 1;
          }
        }
      });

      $scope.total_inbox = inbox;
      $scope.total_unread = unread;
    });

    $scope.refreshMessages = function() {
      Messages.query({'receiver': MeanUser.user._id, 'where': 'sender subject date folder status'}, function(messages) {
        $scope.my_messages = $filter('orderBy')(messages, '-date', false);
        $scope.my_inbox_messages = $filter('filter')($scope.my_messages, {'folder': 'inbox'}, true);
        $scope.my_trash_messages = $filter('filter')($scope.my_messages, {'folder': 'trash'}, true);

        $scope.total_messages = $scope.my_messages.length;

        var unread = 0;
        var inbox = 0;
        $scope.my_messages.forEach(function(message) {
          if(message.folder === 'inbox') {
            inbox = inbox + 1;
          
            if(message.status === 'unread') {
              unread = unread + 1;
            }
          }
        });

        $scope.total_inbox = inbox;
        $scope.total_unread = unread;
      });
    };

    $scope.mySentMessages = function() {
      Messages.query({'sender': MeanUser.user._id, 'where': 'sender receiver subject date folder status'}, function(messages) {
        $scope.my_sent_messages = $filter('orderBy')(messages, '-date', false);
      });
    };

    $scope.getSendersName = function(message) {
      if(!$scope.users) return;

      var user = $filter('filter')($scope.users, {'_id': message.sender}, true);
      if(!user) {
        console.log('problem in getSendersName: ' + message.sender);
        return;
      } else if(user.length !== 1) {
        console.log('in getSendersName and there is a problem with the number users returned ' + user.length);
        return;
      }
      return user[0].name;
    };

    $scope.getReceiversName = function(message) {
      if(!$scope.users) return;
      
      //get just the first receiver since we only support one at this time
      var user = $filter('filter')($scope.users, {'_id': message.receiver[0]}, true)[0];
      if(!user) {
        console.log('problem in getReceiversName: ' + message.receiver[0]);
      }
      return user.name;
    };

    $scope.setMessageDetail = function(message) {
      MessageDetail.set(message);
    };

    $scope.moveToArchive = function(msg) {
      //if(msg.sender === MeanUser.user._id) return;

      if(msg.folder === 'trash') {
        //this message is already in trash so we're gonna
        //move it to the archives and remove from the active list
        var tmp = new Archives({
          sender: msg.sender,
          receiver: msg.receiver,
          date: msg.date,
          status: msg.status,
          folder: msg.folder,
          subject: msg.subject,
          body: msg.body
        });

        tmp.$save();
        msg.$delete();
      }
    };

    $scope.deleteItems = function(val) {
      if(val === '0') {//coming from inbox
        for (var i = $scope.my_inbox_messages.length - 1; i >= 0; i--) {
          if ($scope.selectedItems[i]) {
            //delete row from data
            var message = $scope.my_inbox_messages.splice(i, 1);
            if(message[0].status === 'unread') {
              $scope.total_unread = $scope.total_unread - 1;
            }
            message[0].folder = 'trash';
            message[0].$update();
            //delete rowSelection property
            delete $scope.selectedItems[i];
          }
        }
      } else if(val === '1') {//coming from trash
        for (var i = $scope.my_trash_messages.length - 1; i >= 0; i--) {
          if ($scope.selectedItems[i]) {
            //delete row from data
            var message = $scope.my_trash_messages.splice(i, 1);
            if(message[0].status === 'unread') {
              $scope.total_unread = $scope.total_unread - 1;
            }
            $scope.moveToArchive(message[0]);
            //delete rowSelection property
            delete $scope.selectedItems[i];
          }
        }
      }
    };

    $scope.checkSelection = function(id) {
      var index = $scope.selectedItems.indexOf(id);
      if(index === -1) {
        $scope.selectedItems.push(id);
      } else {
        $scope.selectedItems.splice(index, 1);
      }
    };

  }
]);



// WEBPACK FOOTER //
// ./packages/custom/messages/public/controllers/messages.js